// src/services/api/user.js
import { apiRequest } from "@/services/api/apiClient.js";
import {AttributeEntity} from "@/entities/AttributeEntity.js";
const entity = new AttributeEntity()
export async function getAttribute({ page = 1, limit = 10, ...filters }) {

    return apiRequest({
        client: window.API_ISP,
        method: "get",
        url: "radius/attribute",
        params: { page, limit, ...filters },
    });
}

export async function getAttributeById({id}) {
    return apiRequest({
        client: window.API_ISP,
        method: "get",
        url: `/radius/attribute/${id}`
    });
}

export async function deleteAttribute({ id }) {
    return apiRequest({
        client: window.API_ISP,
        method: "delete",
        url: `/radius/attribute/${id}`
    });
}

export async function saveAttribute(data) {
    const isUpdate = !!data.id;
    let url = isUpdate
        ? entity.getUrl(entity.endpoints.get, { id: data.id })
        : entity.endpoints.create;

    const response = apiRequest({
        client: window.API_ISP,
        method: isUpdate ? "put" : "post",
        url,
        body: data,
    });

    if(response.status !== data.status && isUpdate) {
        const statusChange = data.status ? 'activate' : 'deactivate';
        let urlStatusChange = entity.getUrl(entity.endpoints[statusChange], { id: data.id });

        await apiRequest({
            client: window.API_ISP,
            method: "put",
            url: urlStatusChange,
            body: {
                name
            },
        });
    }

    return response;
}
